import api from "@/modules/api";

export const categories = [
    {value: 'ACTIVE', text: 'Реестр действующих сервисов'},
    {value: 'PROTO', text: 'Реестр прототипов сервисов'},
    {value: 'PILOT', text: 'Реестр сервисов для пилотной апробации'},
    {value: 'RECON', text: 'Реестр рекомендуемых сервисов'},
    {value: 'ARCHIVE', text: 'Реестр архивных сервисов'}
]

export function getCategoryText(categoryValue){
    return categories.find(e=>e.value===categoryValue)?.text
}

export async function loadConfig(){
    let req = await api.get("/servicemap/config")
    if(req.ok){
        const config = JSON.parse(req.payload.configJson);
        return config;
    } else {
        alert('Ошибка загрузки данных')
    }
}

export async function saveConfig(configJson){
    let req = await api.postJson("/servicemap/config", configJson)
    if(req.ok){
        return req.payload
    } else {
        alert('Ошибка загрузки данных')
    }
}

export async function loadServices(){
    let req = await api.get("/servicemap/service")
    if(req.ok){
        const services = JSON.parse(req.payload.valueJson)
        return services
    } else {
        alert('Ошибка загрузки данных')
    }
}

export async function saveServices(servicesJson){
    let req = await api.postJson("/servicemap/service", servicesJson)
    if(req.ok){
        return req.payload
    } else {
        alert('Ошибка загрузки данных')
    }
}

export async function addView(data){
    console.log('addView data', data)
    let req = await api.postJson("/servicemap/addview", data)
    if(req?.ok){
        return req?.payload
    } else {
        alert('Ошибка загрузки данных')
    }
}

export async function addDownload(data){
    console.log('addDownload data', data)
    let req = await api.postJson("/servicemap/adddownload", data)
    if(req?.ok){
        return req?.payload
    } else {
        alert('Ошибка загрузки данных')
    }
}

export function uuidv4() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
}


export async  function uploadFile(file, meta){
    if (file.size > 52428800) {
        alert('Файл больше 50Мб. Загрузите, пожалуйста, файл с меньшим размером');
        return null
    }
    let formData = new FormData();
    formData.append('file', file);
    if(meta) {
        formData.append('meta', meta)
    }
    let req = await api.postFile('/s3/', {}, formData, 'POST');
    console.log('req', req)
    if (req.ok) {
        console.log('upload ok');
        return req.payload
    } else {
        alert('Ошибка загрузки файла: ' + req.error)
        console.log('upload error', req.error)
    }
}


export function truncateStr(str, n) {
    if(!str)return str
    if (str.length > n) {
        return str.substring(0, n - 3) + "..." + str.substring(str.length - 6, str.length)
    }
    return str
}

